import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private readonly uploadedFiles: { [key: string]: File[] } = {};

  addFile(key: string, file: File): void {
    if (!this.uploadedFiles[key]) {
      this.uploadedFiles[key] = [];
    }
    this.uploadedFiles[key].push(file);
  }

  addFiles(key: string, files: File[]): void {
    this.uploadedFiles[key] = files;
  }

  removeFile(key: string, index: number): void {
    if (this.uploadedFiles[key]) {
      this.uploadedFiles[key].splice(index, 1);
    }
  }

  getFiles(key: string): File[] {
    return this.uploadedFiles[key] || [];
  }
}
